import React, {useEffect} from "react";
import MetaTags from 'react-meta-tags';

function MetaTag(props) {
    //
    // if(props)
    return <></>
    return (
        <MetaTags>
            <meta name="description"
                  content="Porn JAV HD Online Sex Videos HD full Streaming Xnxx, JAVHD Xvideos, Pornhub Uncensored Funlove With Full Top 1 Rated And 5 Stars Japanese Porn"/>
            <meta name="robots" content="follow, index"/>
            <link rel="canonical" href="https://funlove.info/"/>
            <link rel="next" href="https://funlove.info/movies"/>
            <meta property="og:locale" content="en_us"/>
            <meta property="og:type" content="website"/>
            <meta property="og:title"
                  content="Watch JAV Online | JAV Free | Asian Sex Videos | Funlove"/>
            <meta property="og:description"
                  content="Porn JAV HD Online Sex Videos HD full Streaming Xnxx, JAVHD Xvideos, Pornhub Uncensored Funlove With Full Top 1 Rated And 5 Stars Japanese Porn"/>
            <meta property="og:url" content="https://funlove.info/"/>
            <meta property="og:site_name" content="Funlove"/>
            <meta name="twitter:card" content="summary_large_image"/>
            <meta name="twitter:title"
                  content="Watch JAV Online | JAV Free | Asian Sex Videos | JAV Funlove"/>
            <meta name="twitter:description"
                  content="Porn JAV HD Online Sex Videos HD full Streaming Xnxx, JAVHD Xvideos, Pornhub Uncensored Funlove With Full Top 1 Rated And 5 Stars Japanese Porn"/>
            <meta name="twitter:site" content="@funlove"/>

        </MetaTags>
    );

}

export default MetaTag;
